/* ==========================================================================
   Homepage FAQ - BB2  →  sections/homepage-faq-bb2.liquid
   Accordion behavior plus the progressive "View More" reveal.

   Loaded with `defer`, so the definition may register before or after the
   section markup exists — custom elements upgrade either way, which is also
   what keeps this working when the theme editor re-renders the section.
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('hp-faq-bb2')) return;

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollTo(element, block) {
    if (!element) return;
    element.scrollIntoView({
      block: block,
      behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
    });
  }

  customElements.define(
    'hp-faq-bb2',
    class HpFaqBB2 extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-faq-list]');
        if (!this.list) return;

        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-faq-item]'));
        this.extras = this.items.filter(function (item) {
          return item.hasAttribute('data-faq-extra');
        });

        if (this.dataset.singleOpen === 'true') this.bindAccordion();
        this.bindReveal();
      }

      // Only one answer stays open, so the list never becomes a wall of text.
      bindAccordion() {
        var self = this;
        this.items.forEach(function (item) {
          item.addEventListener('toggle', function () {
            if (!item.open) return;
            self.items.forEach(function (other) {
              if (other !== item) other.open = false;
            });
          });
        });
      }

      bindReveal() {
        var self = this;

        this.button = this.querySelector('[data-faq-more]');
        if (!this.button || this.extras.length === 0) return;

        this.status = this.querySelector('[data-faq-status]');
        this.label = this.button.querySelector('[data-faq-more-label]');
        this.count = this.button.querySelector('[data-faq-more-count]');
        this.srCount = this.button.querySelector('[data-faq-more-sr]');

        this.step = parseInt(this.dataset.step, 10) || 5;
        this.moreLabel = this.dataset.moreLabel || 'View More';
        this.lessLabel = this.dataset.lessLabel || 'View Less';
        this.shown = 0;

        this.button.addEventListener('click', function () { self.onClick(); });
        this.render(true);
      }

      onClick() {
        if (this.shown >= this.extras.length) {
          this.shown = 0;
          this.render();
          scrollTo(this.button, 'center');
          return;
        }

        var firstNew = this.extras[this.shown];
        this.shown = Math.min(this.extras.length, this.shown + this.step);
        this.render();
        // Keep the newly revealed block in view instead of jumping the page.
        scrollTo(firstNew, 'nearest');
      }

      render(initial) {
        var previous = this.revealed || 0;

        this.extras.forEach(function (item, i) {
          if (i < this.shown) {
            item.removeAttribute('hidden');
          } else {
            item.open = false; // never leave an open answer hidden
            item.setAttribute('hidden', '');
          }
        }, this);

        var remaining = this.extras.length - this.shown;
        var all = remaining === 0;

        // .is-less flips the plus to a minus only once the button's job becomes
        // collapsing — mid-reveal it still adds more.
        this.button.classList.toggle('is-less', all);
        this.button.setAttribute('aria-expanded', this.shown > 0 ? 'true' : 'false');
        if (this.label) this.label.textContent = all ? this.lessLabel : this.moreLabel;
        if (this.count) this.count.textContent = all ? '' : '(' + remaining + ')';
        // The visible count is aria-hidden decoration; this carries it to AT.
        if (this.srCount) {
          this.srCount.textContent = all
            ? this.dataset.labelAllShown || 'All questions shown'
            : remaining + ' ' + (this.dataset.labelRemaining || 'more questions available');
        }

        this.revealed = this.shown;
        if (!initial) this.announce(this.shown, previous);
      }

      announce(current, previous) {
        if (!this.status) return;
        var delta = current - previous;
        var template = delta > 0
          ? this.dataset.labelShown || 'Showing [count] more questions'
          : this.dataset.labelCollapsed || 'Collapsed back to the first questions';
        this.status.textContent = delta > 0
          ? template.replace('[count]', String(delta))
          : template;
      }
    }
  );
})();
